import { Link, useLocation } from 'react-router-dom';
import {
  LayoutDashboard,
  FileText,
  Heart,
  BookOpen,
  Trophy,
  Settings,
} from 'lucide-react';
import { useAuth } from '@/contexts/AuthContext';

const repItems = [
  { label: 'My Deals', icon: LayoutDashboard, to: '/rep' },
  { label: 'Wishlist', icon: Heart, to: '/wishlist' },
  { label: 'Programs', icon: BookOpen, to: '/programs' },
  { label: 'Settings', icon: Settings, to: '/settings' },
];

const managerItems = [
  { label: 'Dashboard', icon: LayoutDashboard, to: '/dashboard' },
  { label: 'View Deals', icon: FileText, to: '/deals' },
  { label: 'Wishlist', icon: Heart, to: '/wishlist' },
  { label: 'Programs', icon: BookOpen, to: '/programs' },
  { label: 'Leaderboard', icon: Trophy, to: '/leaderboard' },
  { label: 'Settings', icon: Settings, to: '/settings' },
];

export function MobileNav() {
  const { pathname } = useLocation();
  const { role } = useAuth();
  const isManager = role === 'manager' || role === 'admin';
  const items = isManager ? managerItems : repItems;

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 bg-card border-t border-border lg:hidden">
      <div className="flex items-center justify-around h-16">
        {items.map((item) => {
          const active =
            pathname === item.to ||
            (item.to !== '/rep' && item.to !== '/dashboard' && pathname.startsWith(item.to));
          return (
            <Link
              key={item.label}
              to={item.to}
              className={`flex flex-col items-center gap-1 px-3 py-2 text-xs transition-colors ${
                active ? 'text-primary' : 'text-muted-foreground'
              }`}
            >
              <item.icon className="h-5 w-5" />
              {item.label}
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
